// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { NormalTraffic, NormalTrafficT } from "./normal-traffic";
import { ValuedTraffic, ValuedTrafficT } from "./valued-traffic";

export enum TrafficVariant {
  NONE = 0,
  NormalTraffic = 1,
  ValuedTraffic = 2,
}

export function unionToTrafficVariant(
  type: TrafficVariant,
  accessor: (obj: NormalTraffic | ValuedTraffic) => NormalTraffic | ValuedTraffic | null,
): NormalTraffic | ValuedTraffic | null {
  switch (TrafficVariant[type]) {
    case "NONE":
      return null;
    case "NormalTraffic":
      return accessor(new NormalTraffic())! as NormalTraffic;
    case "ValuedTraffic":
      return accessor(new ValuedTraffic())! as ValuedTraffic;
    default:
      return null;
  }
}

export function unionListToTrafficVariant(
  type: TrafficVariant,
  accessor: (
    index: number,
    obj: NormalTraffic | ValuedTraffic,
  ) => NormalTraffic | ValuedTraffic | null,
  index: number,
): NormalTraffic | ValuedTraffic | null {
  switch (TrafficVariant[type]) {
    case "NONE":
      return null;
    case "NormalTraffic":
      return accessor(index, new NormalTraffic())! as NormalTraffic;
    case "ValuedTraffic":
      return accessor(index, new ValuedTraffic())! as ValuedTraffic;
    default:
      return null;
  }
}

export type TrafficVariantT =
  | { type: "NONE"; value: null }
  | { type: "NormalTraffic"; value: NormalTrafficT }
  | { type: "ValuedTraffic"; value: ValuedTrafficT };
